import React from 'react';
import {Link} from 'react-router-dom';

const ExtraIcon = ({...props}) => {

    const determineVideoOrDocument = () => {
        if (props.videoSource !== undefined) {
            return <Link to={{pathname: `/extras/${props.slug}`, state: {video: props}}}
                         className="extra-icon">
                <img alt="" src={props.imgSrc}/>
                <p>{props.title}</p>
            </Link>
        } else {
            return <a href={props.pdfSource} target="_blank"
                      className="extra-icon">
                <img alt="" src={props.imgSrc}/>
                <p>{props.title}</p>
            </a>
        }
    }


    return (
        determineVideoOrDocument()
    )
};


export default ExtraIcon;